import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';

import {
  //Twitter,
  Facebook,
  //Instagram,
  Youtube
} from 'mdi-material-ui';

const styles = theme => ({
  footer: {
    background: theme.palette.grey.main,
    //position: 'relative',
    //marginTop: -246,
    //height: 246,
    padding: 20,
  },
  footerSection: {
    color: theme.palette.secondary.main
  },
  footerItem: {
    paddingLeft: 0
  },
  footerText: {
    cursor: 'pointer',
    color: theme.palette.common.white,
    '&:hover': {
      textDecoration: 'underline',
    },
    '& span': {
      color: theme.palette.common.white,
    }
  },
  icons: {
    marginTop: 50
  },
  icon: {
    color: theme.palette.secondary.main,
    height: 30,
    width: 30,
  },
  iconBtn: {
    margin: '0px 10px',
    border: '2px solid',
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.main,
      '& span>svg': {
        color: theme.palette.grey.main
      }
    }
  },
  copy: {
    marginTop: 50,
    color: theme.palette.common.white
  },
  link: {
    color: theme.palette.common.white,
    fontSize: 13,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  }
});



class Footer extends Component {

  social = name => evt => {
    window.open(name, '_blank');
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.footer}>
        <Grid container
          direction="row"
          alignItems="center"
          justifyContent="center"
          className={classes.spacing}
        >
          <Grid item xs={12} sm={8}>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.footerSection} variant="button">
                  Links
                </Typography>
                <List dense>
                  <ListItem className={classes.link} component={Link} to="/media">Photos</ListItem>
                  <ListItem className={classes.link} component={Link} to="/events">Events</ListItem>
                  <ListItem className={classes.link} component={Link} to="/links">Links</ListItem>
                  <ListItem className={classes.link} component={Link} to="/programs/examinations">Piano Guild</ListItem>
                </List>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography className={classes.footerSection} variant="button">
                  Info
                </Typography>
                <List dense>
                  <ListItem className={classes.link} component={Link} to="/about">About</ListItem>
                  <ListItem className={classes.link} component={Link} to="/programs/studio-classes">Programs</ListItem>
                  <ListItem className={classes.link} component={Link} to="/subjects">Subjects</ListItem>
                  <ListItem className={classes.link} component={Link} to="/contact">Contact Us</ListItem>
                </List>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography className={classes.footerSection} variant="button">
                  Stay Connected
                </Typography>

                <div className={classes.icons}>
                  <IconButton className={classes.iconBtn} onClick={this.social('https://www.facebook.com/drjmusicologystudio')}>
                    <Facebook className={classes.icon}/>
                  </IconButton>
                  {/*
                  <IconButton className={classes.iconBtn} onClick={this.social('twitter')}>
                    <Twitter className={classes.icon}/>
                  </IconButton>
                  <IconButton className={classes.iconBtn} onClick={this.social('instagram')}>
                    <Instagram className={classes.icon}/>
                  </IconButton>
                  */}
                  <IconButton className={classes.iconBtn} onClick={this.social('https://www.youtube.com/channel/UC0LAY5xS4QcxQXx5GdcoVOw')}>
                    <Youtube className={classes.icon}/>
                  </IconButton>
                </div>

                <Typography className={classes.copy} variant="body1">
                  &copy; 2019 Musicology Studio. All right reserved.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </div>
    )
  }
}

export default withStyles(styles)(Footer);

